import { defineNuxtPlugin } from '#app';
import VConsole from 'vconsole';

export default defineNuxtPlugin(() => {
  if (process.client && (process.env.NODE_ENV === 'development' || import.meta.env.VITE_SERVER_ENV === 'test')) {
    const vConsole = new VConsole();
    console.log('vConsole is initialized');
  }
});
